<template>
  <div class="overflow-hidden">
    <section class="cp-page py-4">
      <header-help :is-loading="isLoading"></header-help>
      
      <!-- Background animated orbs using Stella brand colors -->
      <div class="cp-bg-orb cp-bg-orb--1"></div>
      <div class="cp-bg-orb cp-bg-orb--2"></div>

      <div class="container position-relative my-auto" style="z-index: 1;">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
            <div class="cp-content-card p-4 p-md-5 text-center">
              
              <div class="d-inline-flex align-items-center justify-content-center mb-3" 
                   style="width: 64px; height: 64px; border-radius: 50%; background: rgba(229,59,185,0.15); color: #E53BB9; font-size: 26px; box-shadow: 0 0 25px rgba(229,59,185,0.3);">
                <i class="fa fa-paper-plane"></i>
              </div>

              <h3 class="text-white font-weight-700 mb-1">
                Say Hello to {{ invitee.name }}!
              </h3>
              <p class="text-white-50 font-size-14 mb-3">
                Your direct message line is now active. Send your first message to break the ice:
              </p>

              <global-message></global-message>

              <!-- Icebreaker Prompt Chips -->
              <div class="icebreaker-container">
                <div class="icebreaker-chip" @click="goToMessage(`Hey @${invitee.name}! Super excited to be here 👋`)">
                  <span>"Hey @{{ invitee.name }}! Super excited to be here 👋"</span>
                  <i class="fa fa-chevron-right font-size-12 text-white-50"></i>
                </div>
                <div class="icebreaker-chip" @click="goToMessage(`Loved your latest content! Keep it up ✨`)">
                  <span>"Loved your latest content! Keep it up ✨"</span>
                  <i class="fa fa-chevron-right font-size-12 text-white-50"></i>
                </div>
                <div class="icebreaker-chip" @click="goToMessage(`Have a question about your custom requests 💬`)">
                  <span>"Have a question about your custom requests 💬"</span>
                  <i class="fa fa-chevron-right font-size-12 text-white-50"></i>
                </div>
              </div>

              <div class="mt-4 d-flex align-items-center justify-content-center" style="gap: 12px;">
                <button type="button" @click="skip()"
                  class="cp-btn-ghost flex-fill">
                  Dashboard
                </button>
                <button type="button" @click="goToMessage()"
                  class="cp-btn-primary flex-fill">
                  <i class="fa fa-comment-dots me-1"></i> Open Chat
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {httpMixin} from "@/mixin/http-mixin";
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import LoadingModal from "@/components/module/shared/LoadingModal";
import HeaderHelp from "@/components/module/influencer/shared/HeaderHelp";
import {SERVICE_CONTENT} from "@/properties/micro-service";

export default {
  name: 'messageCta',
  mixins: [httpMixin],
  components: {GlobalMessage, LoadingModal, HeaderHelp},
  data() {
    return {
      invitee: {},
    }
  },
  created() {
    this.invitee = this.getInvitee();
    if (this.$route.query.saved) {
      this.setMessage('SAVED.SUCCESSFULLY');
    }
  },
  methods: {
    ...mapGetters(['getUser', 'getInvitee']),
    ...mapActions(['setMessage']),
    goToMessage(draftText) {
      const query = draftText ? { draft: draftText } : {};
      this.$router.push({
        name: 'CustomerDirectMessage', 
        params: { customerId: this.invitee.id },
        query
      });
    },
    skip() {
      let url = `${SERVICE_CONTENT}/api/v1/customers/${this.getUser().id}/content/available`;
      this.getData(url, (contentAvailable) => {
        if (contentAvailable) {
          this.$router.replace({name: 'CustomerBonusContentList'});
        } else {
          this.$router.replace({name: 'CustomerDashboardMobile'});
        }
      });
    },
  }
}
</script>
